import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Autoplay, Navigation, Pagination } from "swiper/modules";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import Carousel from "bootstrap/js/dist/carousel";
import { Link } from "react-router-dom";
import NewsService from "../services/news.service";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);

  useEffect(() => {
    NewsService.getAll({ limit: 10 })
      .then((res) => setNews(res.data || []))
      .catch(() => setNews([]));
  }, []);

  // Initialize the Bootstrap hero carousel explicitly (rendered by React
  // after the data-API auto-init has already run on page load).
  useEffect(() => {
    const el = document.getElementById("carouselExampleDark");
    if (!el) return;
    const carousel = new Carousel(el, {
      interval: 5000,
      ride: "carousel",
      pause: "hover",
      wrap: true,
    });
    carousel.cycle();
    return () => {
      carousel.dispose();
    };
  }, []);

  return (
    <div className="home">
      {/* <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="5000">
            <img src="assets/img/h2.png" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-none d-md-block"></div>
          </div>
          <div className="carousel-item" data-bs-interval="5000">
            <img src="assets/img/slide6.jpg" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-none d-md-block"></div>
          </div>
          <div className="carousel-item" data-bs-interval="5000">
            <img src="assets/img/slide4.jpg" className="d-block w-100" alt="..." />
            <div className="carousel-caption d-none d-md-block"></div>
          </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div> */}

      <div className="container-fluid landing-bigpic d-flex align-items-center justify-content-center">
        <div className="c-white mb-5 pb-5 text-center mt-5">
          <h1>ĐỒNG HÀNH CÙNG <span className='c-red'>NHÀ HÀNG</span></h1>
          <h1>TỪ Ý TƯỞNG ĐẾN VẬN HÀNH</h1>
          <p className="mt-4">Sản xuất thiết bị bếp công nghiệp, thiết bị nhà hàng, hệ thống hút khói, giải pháp F&amp;B toàn diện</p>
          <div className="text-center mt-5">
            <Link to="/" className="btn btn-primary fs-4 py-3 ps-4 pe-5" role="button"><i className="icon icon-phone"></i> Nhận tư vấn</Link>
          </div>
          {/* <div className="landing-bigpic__summary d-flex gap-5 mt-5 pt-5">
            <div className="landing-bigpic__summary__item d-flex flex-column align-items-center c-white">
              <i className="icon icon-shop"></i>
              <h4>Hơn 500 dự án</h4>
              <div>Trên toàn quốc</div>
            </div>
            <div className="landing-bigpic__summary__item d-flex flex-column align-items-center c-white">
              <i className="icon icon-star"></i>
              <h4>Thiết kế tối ưu</h4>
              <div>Theo mô hình kinh doanh</div>
            </div>
            <div className="landing-bigpic__summary__item d-flex flex-column align-items-center c-white">
              <i className="icon icon-diamond-1"></i>
              <h4>Sản xuất theo yêu cầu</h4>
              <div>Kích thước linh hoạt</div>
            </div>
            <div className="landing-bigpic__summary__item d-flex flex-column align-items-center c-white">
              <i className="icon icon-wrench"></i>
              <h4>Thi công trọn gói</h4>
              <div>Đúng tiến độ</div>
            </div>
            <div className="landing-bigpic__summary__item d-flex flex-column align-items-center c-white">
              <i className="icon icon-ok-circled-1"></i>
              <h4>Bảo hành &amp; hỗ trợ lâu dài</h4>
              <div>Đồng hành vận hành</div>
            </div>
          </div> */}
        </div>
      </div>

      <div className="container d-flex align-items-center">
        <div className="landing-bigpic__summary d-flex gap-5 mt-5 row">
          <div className="landing-bigpic__summary__item d-flex flex-column align-items-center col-md-auto col-12 px-md-0">
            <i className="icon icon-shop c-red"></i>
            <h4 className="text-center">Hơn 500 dự án</h4>
            <div>Trên toàn quốc</div>
          </div>
          <div className="landing-bigpic__summary__item d-flex flex-column align-items-center col-md-auto col-12 px-md-0">
            <i className="icon icon-diamond-1 c-red"></i>
            <h4 className="text-center">Thiết kế tối ưu</h4>
            <div>Theo mô hình kinh doanh</div>
          </div>
          <div className="landing-bigpic__summary__item d-flex flex-column align-items-center col-md-auto col-12 px-md-0">
            <i className="icon icon-star c-red"></i>
            <h4 className="text-center">Sản xuất theo yêu cầu</h4>
            <div>Kích thước linh hoạt</div>
          </div>
          <div className="landing-bigpic__summary__item d-flex flex-column align-items-center col-md-auto col-12 px-md-0">
            <i className="icon icon-wrench-2 c-red"></i>
            <h4 className="text-center">Thi công trọn gói</h4>
            <div>Đúng tiến độ</div>
          </div>
          <div className="landing-bigpic__summary__item d-flex flex-column align-items-center col-md-auto col-12 px-md-0">
            <i className="icon icon-shield c-red"></i>
            <h4 className="text-center">Bảo hành &amp; hỗ trợ lâu dài</h4>
            <div>Đồng hành vận hành</div>
          </div>
        </div>

      </div>

      {/* <div className="container mt-3" id="gioi-thieu">
        <div className="company-info row col-12">
          <section className="company-intro">
            <p>
              Công Ty TNHH Thương Mại Và Sản Xuất Tinh Anh được thành lập năm 2007, có
              kinh nghiệm nhiều năm hoạt động trong lĩnh vực cung cấp ra thị trường Việt
              Nam các loại:
            </p>

            <ul>
              <li><strong>Bếp công nghiệp:</strong> bếp điện đơn, bếp điện từ công nghiệp</li>
              <li><strong>Bếp nướng, lò nướng:</strong> lò nướng gia cầm, bếp nướng không khói,…</li>
              <li><strong>Thiết bị bếp khác:</strong> nồi nấu soup, thiết bị hâm nóng thức ăn,…</li>
            </ul>

            <p>
              Chúng tôi cam kết cung cấp sản phẩm chính hãng với tuổi thọ trên 3 năm,
              chất lượng với giá cả phải chăng.
            </p>

            <h4>Ngành nghề kinh doanh</h4>
            <ul>
              <li>Thiết Bị Bếp Nhà Hàng, Khách Sạn, Quầy Bar – Nhập Khẩu Và Phân Phối</li>
              <li>Bếp Công Nghiệp Inox, Thiết Bị Bếp Công Nghiệp – Sản Xuất Và Lắp Đặt</li>
            </ul>
          </section>
        </div>
      </div> */}

      <div className="container mt-5">
        <div className="text-center"><h2 id="san-pham-noi-bat" className="fw-bold">BẾP LẨU NƯỚNG</h2>
          <p>Bếp nướng, ống hút, chao điện và phụ kiện lẩu nướng</p></div>
        <div className="d-flex justify-content-center mt-5 gap-2 row">
          <img className="col-12 col-md-2" src="assets/img/a1.jpg" alt="Sản phẩm 1" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a2.jpg" alt="Sản phẩm 2" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a3.jpg" alt="Sản phẩm 3" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a4.jpg" alt="Sản phẩm 4" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a5.jpg" alt="Sản phẩm 5" width="200" />
        </div>
        <div className="text-center mt-3">
          <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
        </div>
      </div>

      <div className="container mt-5">
        <div className="text-center"><h2 id="san-pham-noi-bat" className="fw-bold">BẾP CÔNG NGHIỆP</h2>
          <p>Bếp công nghiệp, thiết bị bếp inox và phụ kiện bếp công nghiệp</p></div>
        <div className="d-flex justify-content-center mt-5 gap-2 row">
          <img className="col-12 col-md-2" src="assets/img/a1.jpg" alt="Sản phẩm 1" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a2.jpg" alt="Sản phẩm 2" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a3.jpg" alt="Sản phẩm 3" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a4.jpg" alt="Sản phẩm 4" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a5.jpg" alt="Sản phẩm 5" width="200" />
        </div>
        <div className="text-center mt-3">
          <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
        </div>
      </div>

      <div className="container mt-5">
        <div className="text-center"><h2 id="san-pham-noi-bat" className="fw-bold">THIẾT BỊ NHÀ HÀNG</h2>
          <p>Thiết bị nhà hàng, bếp inox và phụ kiện nhà hàng</p></div>
        <div className="d-flex justify-content-center mt-5 gap-2 row">
          <img className="col-12 col-md-2" src="assets/img/a1.jpg" alt="Sản phẩm 1" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a2.jpg" alt="Sản phẩm 2" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a3.jpg" alt="Sản phẩm 3" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a4.jpg" alt="Sản phẩm 4" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a5.jpg" alt="Sản phẩm 5" width="200" />
        </div>
        <div className="text-center mt-3">
          <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
        </div>
      </div>

      {/* <div className="container mt-5">
        <div className="text-center"><h2 id="san-pham-noi-bat">Sản phẩm nổi bật</h2></div>
        <div className="d-flex justify-content-center gap-5 row">
          <img className="col-12 col-md-2" src="assets/img/a1.jpg" alt="Sản phẩm 1" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a2.jpg" alt="Sản phẩm 2" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a3.jpg" alt="Sản phẩm 3" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a4.jpg" alt="Sản phẩm 4" width="200" />
          <img className="col-12 col-md-2" src="assets/img/a5.jpg" alt="Sản phẩm 5" width="200" />
        </div>
        <div className="text-center mt-3">
          <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
        </div>
      </div> */}

      <div className='container-fluid bg-black pt-5 mt-5'>
        <div className="container text-center text-white">
          <h5 className="c-red">GIẢI PHÁP</h5>
          <h2 className="mt-3 fw-bold">HỆ THỐNG HÚT KHÓI CHO NHÀ HÀNG LẨU NƯỚNG</h2>
          {/* <h5 className=""></h5> */}
          <p className="desc mb-5">Tinh Anh cung cấp giải pháp hệ thống hút khói chuyên nghiệp, đảm bảo không gian thông thoáng sạch, vận hành êm, phù hợp cho từng mô hình nhà hàng.</p>

          <div className="row">
            <div className="col-12 col-md-4 pb-5">
              <img src={'assets/img/l4.png'} className="card-img-top object-fit-cover rounded mb-3" alt="..." height="200" width="100" />
              <h5 className="fw-bold mb-3">HÚT ÂM CHO BẾP NƯỚNG</h5>
              <div className="d-flex justify-content-center">
                <ul className="text-start ps-0">
                  <li><i className="icon-check c-red"></i>Hút khói trực tiếp tại bàn</li>
                  <li><i className="icon-check c-red"></i>Âm dưới sàn, thẩm mỹ cao</li>
                  <li><i className="icon-check c-red"></i>Không chiếm không gian</li>
                  <li><i className="icon-check c-red"></i>Phù hợp nhà hàng hiện đại</li>
                </ul>
              </div>
              <div className="text-center mt-3">
                <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
              </div>
            </div>

            <div className="col-12 col-md-4 pb-5">
              <img src={'assets/img/l1.png'} className="card-img-top object-fit-cover rounded mb-3" alt="..." height="200" width="100" />
              <h5 className="fw-bold mb-3">HÚT DƯƠNG CHO BẾP NƯỚNG</h5>
              <div className="d-flex justify-content-center">
                <ul className="text-start ps-0">
                  <li><i className="icon-check c-red"></i>Sử dụng chao hút khói phía trên</li>
                  <li><i className="icon-check c-red"></i>Thi công đơn giản</li>
                  <li><i className="icon-check c-red"></i>Chi phí tối ưu</li>
                  <li><i className="icon-check c-red"></i>Phù hợp nhiều mô hình</li>
                </ul>
              </div>
              <div className="text-center mt-3">
                <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
              </div>
            </div>

            <div className="col-12 col-md-4 pb-5">
              <img src={'assets/img/l3.png'} className="card-img-top object-fit-cover rounded mb-3" alt="..." height="200" width="100" />
              <h5 className="fw-bold mb-3">HÚT ÂM + HÚT TRẦN CHO BẾP LẨU</h5>
              <div className="d-flex justify-content-center">
                <ul className="text-start ps-0">
                  <li><i className="icon-check c-red"></i>Hút khói tại bàn kết hợp hút trần</li>
                  <li><i className="icon-check c-red"></i>Kiểm soát khói và mùi hiệu quả</li>
                  <li><i className="icon-check c-red"></i>Hiệu suất cao, không ám mùi</li>
                  <li><i className="icon-check c-red"></i>Đảm bảo không gian thoáng sạch</li>
                </ul>
              </div>
              <div className="text-center mt-3">
                <Link to="/catalog" className="btn btn-primary" role="button">Xem thêm</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="text-center mb-3"><h2 id="tin-tuc" className="fw-bold">{t("news.title")}</h2></div>
        {news.length === 0 ? (
          <p className="text-center text-muted">{t("news.empty")}</p>
        ) : (
          <ul className="home-news-list">
            {news.map((n) => (
              <li key={n.id} className="home-news-item d-flex justify-content-between align-items-end pb-1">
                <Link to={`/news/${n.id}`} className="home-news-link">
                  {n.title}
                </Link>
                <span className="home-news-date">
                  {new Date(n.createdAt).toLocaleString()}
                </span>
              </li>
            ))}
          </ul>
        )}
        <div className="text-center mt-4">
          <Link to="/news" className="home-news-more" role="button">
            {t("news.readMore")} <span aria-hidden="true">▶</span>
          </Link>
        </div>
      </div>

      <div className="container mt-5">
        <h3 className="text-center fw-bold mb-3" id="doi-tac">CÁC CÔNG TRÌNH TIÊU BIỂU ĐÃ THỰC HIỆN</h3>
        <div id="recipeCarousel" className="recipe-swiper px-0">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={16}
            slidesPerView={1}
            slidesPerGroup={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            loop
            breakpoints={{
              576: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
            }}
          >
            {[
              { img: "dt1.png", title: "Bosam BBQ 1" },
              { img: "dt2.jpg", title: "Bosam BBQ 2" },
              { img: "dt3.jpg", title: "Bosam BBQ 3" },
              { img: "dt4.png", title: "Bosam BBQ 4" },
              { img: "dt5.png", title: "Bosam BBQ 5" },
              { img: "dt6.png", title: "Bosam BBQ 6" },
              { img: "dt7.png", title: "Bosam BBQ 7" },
            ].map((c, i) => (
              <SwiperSlide key={i}>
                <div className="card h-100 bg-transparent border-none">
                  <img src={`assets/img/${c.img}`} className="card-img-top object-fit-cover" alt="..." height="200" width="100" />
                  <div className="card-body pt-1 pb-4 border-none">
                    <p className="card-title text-center">{c.title}</p>
                    {/* <p className="card-text">Some quick example text to build on the card title.</p> */}
                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div className="container mt-5 about">
        <div className="row">
          <div className="col-12 col-md-6">
            <h5 className="c-red fw-bold">VỀ TINH ANH</h5>
            <h2 className="fw-bold">HƠN 15 NĂM ĐỒNG HÀNH<br />CÙNG NGÀNH F&amp;B VIỆT NAM</h2>
            <p>Công ty TNHH Thương Mại và Sản Xuất Tinh Anh được thành lập từ năm 2008, chuyên cung cấp thiết bị bếp, hệ thống hút khói, giải pháp toàn diện cho nhà hàng, khách sạn, resort, khu công nghiệp.</p>
          </div>
          <div className="stats col-12 col-md-6 d-flex justify-content-between align-items-center text-center px-5">
            <div className="stat"><h3 className="c-red fw-bold">500+</h3><h5>Dự án đã thực hiện</h5></div>
            <div className="stat"><h3 className="c-red fw-bold">15+</h3><h5>Năm kinh nghiệm</h5></div>
            <div className="stat"><h3 className="c-red fw-bold">50+</h3><h5>Đối tác lớn</h5></div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Home;
